import type { OfficeHours } from '../api/extractionApi';

export const DAYS: { key: keyof OfficeHours; label: string; short: string }[] = [
  { key: 'monday', label: 'Monday', short: 'Mon' },
  { key: 'tuesday', label: 'Tuesday', short: 'Tue' },
  { key: 'wednesday', label: 'Wednesday', short: 'Wed' },
  { key: 'thursday', label: 'Thursday', short: 'Thu' },
  { key: 'friday', label: 'Friday', short: 'Fri' },
  { key: 'saturday', label: 'Saturday', short: 'Sat' },
  { key: 'sunday', label: 'Sunday', short: 'Sun' },
];

export function formatTime(t: string): string {
  const [h, m] = t.split(':').map(Number);
  const suffix = h >= 12 ? 'PM' : 'AM';
  const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return m === 0 ? `${h12} ${suffix}` : `${h12}:${String(m).padStart(2, '0')} ${suffix}`;
}

export const TIME_OPTIONS = (() => {
  const opts: { value: string; label: string }[] = [];
  for (let h = 5; h <= 23; h++) {
    for (const m of [0, 30]) {
      const val = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      const suffix = h >= 12 ? 'PM' : 'AM';
      const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
      const label =
        m === 0 ? `${h12}:00 ${suffix}` : `${h12}:${String(m).padStart(2, '0')} ${suffix}`;
      opts.push({ value: val, label });
    }
  }
  return opts;
})();

export function formatOfficeHours(hours: OfficeHours | undefined | null): string {
  if (!hours) return 'Not detected';
  const parts = DAYS.filter((d) => hours[d.key]).map(
    (d) => `${d.short}: ${formatTime(hours[d.key]!.open)} – ${formatTime(hours[d.key]!.close)}`,
  );
  return parts.length ? parts.join(', ') : 'Not detected';
}
